import { takeEvery, put, select } from 'redux-saga/effects';

import restaurantsActions from '../actionTypes/restaurantsActions';
import { API_CALL } from '../actionTypes/sharedActions';
import {
  ADD_NEW_RESTAURANT,
  UPDATE_RESTAURANT,
  GET_RESTAURANT_ORDER,
  GET_RESTAURANT_SCHEDULES,
  GET_CUISINES_LIST,
  GET_RESTAURANT_DETAILS,
  CREATE_MEAL_SCHEDULES,
  UPDATE_MEAL_ITEM,
  GET_MEALS,
  ADD_RESTAURANT_MEAL,
  UPDATE_MEAL,
} from '../routes';
import {
  GET_RESTAURANT_MEAL_SCHEDULE,
  GET_RESTAURANT_MEAL_SCHEDULE_SUCCESS,
  GET_RESTAURANT_MEAL_SCHEDULE_FAILED,
  GET_RESTAURANT_ORDER as GET_RESTAURANT_MEAL_ORDER,
  GET_RESTAURANT_ORDER_FAILED,
  GET_RESTAURANT_ORDER_SUCCESS,
} from '../actionTypes/index';
import restaurantMealSchedulesActions from '../actionTypes/restaurantMealSchedulesActions';
import restaurantMealActions from '../actionTypes/restaurantMealActions';

const getRestaurantId = (state) => state.loginReducer.currentUser.resourceable_id;

function* getRestaurantMealSchdule({ payload }) {
  const id = yield select(getRestaurantId);
  yield put({
    type: API_CALL,
    payload: {
      url: GET_RESTAURANT_SCHEDULES.replace(':id', id || payload.id),
      method: 'GET',
      params: payload,
    },
    successAction: GET_RESTAURANT_MEAL_SCHEDULE_SUCCESS,
    failureAction: GET_RESTAURANT_MEAL_SCHEDULE_FAILED,
  });
}

function* getCuisinesList({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: GET_CUISINES_LIST,
      method: 'POST',
      data: payload,
    },
    successAction: restaurantsActions.getCuisinesListSuccess,
    failureAction: restaurantsActions.getCuisinesListFailed,
  });
}

function* getRestaurantDetails({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: GET_RESTAURANT_DETAILS.replace(':id', payload),
      method: 'GET',
      data: payload,
    },
    successAction: restaurantsActions.getRestaurantDetailsSuccess,
    failureAction: restaurantsActions.getRestaurantDetailsFailed,
  });
}

function* getRestaurantMealOrder({ payload }) {
  const id = yield select(getRestaurantId);

  yield put({
    type: API_CALL,
    payload: {
      url: GET_RESTAURANT_ORDER.replace(':id', id),
      method: 'GET',
      data: payload,
    },
    successAction: GET_RESTAURANT_ORDER_SUCCESS,
    failureAction: GET_RESTAURANT_ORDER_FAILED,
  });
}

function* createMealSchedules({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: CREATE_MEAL_SCHEDULES.replace(':id', payload.id),
      method: 'POST',
      data: payload,
    },
    successAction: restaurantMealSchedulesActions.createMealSchedulesSuccess,
    failureAction: restaurantMealSchedulesActions.createMealSchedulesFailed,
  });
}

function* addNewRestaurant({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: ADD_NEW_RESTAURANT,
      method: 'POST',
      data: payload,
    },
    successAction: restaurantsActions.addNewRestaurantSuccess,
    failureAction: restaurantsActions.addNewRestaurantFailed,
  });
}

function* updateRestaurant({ payload }) {
  yield put({
    type: API_CALL,
    payload: {
      url: UPDATE_RESTAURANT.replace(
        ':id',
        payload.get('restaurant[id]'),
      ),
      method: 'PUT',
      data: payload,
    },
    successAction: restaurantsActions.updateRestaurantDetailsSuccess,
    failureAction: restaurantsActions.updateRestaurantDetailsFailed,
  });
}

function* getMeals({ payload }) {
  const id = yield select(getRestaurantId);
  yield put({
    type: API_CALL,
    payload: {
      url: GET_MEALS.replace(':id', id),
      method: 'GET',
      data: payload,
    },
    successAction: restaurantMealActions.getRestaurantMealSuccess,
    failureAction: restaurantMealActions.getRestaurantMealFailed,
  });
}

function* updateMealItem({ payload }) {
  const { id, value } = payload;
  const val = value === 'true';
  yield put({
    type: API_CALL,
    payload: {
      url: UPDATE_MEAL_ITEM.replace(':id', id),
      method: 'PATCH',
      data: { meal: { is_active: !val } },
    },
    successAction: restaurantMealActions.updateMealStatusSuccess, 
    failureAction: restaurantMealActions.addRestaurantMealFailure,
  });
}

function* addMeals({ payload }) {
  const id = yield select(getRestaurantId);
  yield put({
    type: API_CALL,
    payload: {
      url: ADD_RESTAURANT_MEAL.replace(':id', id),
      method: 'POST',
      data: payload,
    },
    successAction: restaurantMealActions.getRestaurantMeal,
    failureAction: restaurantMealActions.addRestaurantMealFailure,
  });
}

function* editRestaurantMeal({ payload }){
  const restaurantId = yield select(getRestaurantId);
  const { values, editMealId } = payload;
  yield put({
    type: API_CALL,
    payload:{
      url: UPDATE_MEAL.replace(':restaurant_id', restaurantId).replace(':meal_id', parseInt(editMealId)),
      method:'PUT',
      data: values
    },
    successAction: restaurantMealActions.getRestaurantMeal,
    failureAction: restaurantMealActions.editRestaurantMealFailure,
  })
}

export default function* watchRestaurantApis() {
  yield takeEvery(restaurantsActions.addNewRestaurant, addNewRestaurant);
  yield takeEvery(restaurantsActions.updateRestaurantDetails, updateRestaurant);
  yield takeEvery(GET_RESTAURANT_MEAL_SCHEDULE, getRestaurantMealSchdule);
  yield takeEvery(GET_RESTAURANT_MEAL_ORDER, getRestaurantMealOrder);
  yield takeEvery(restaurantMealActions.getRestaurantMeal, getMeals);
  yield takeEvery(restaurantMealActions.addRestaurantMeal, addMeals);
  yield takeEvery(restaurantMealActions.editRestaurantMeal, editRestaurantMeal)
  yield takeEvery(restaurantMealActions.updateMealStatus, updateMealItem);
  yield takeEvery(restaurantsActions.getCuisinesList, getCuisinesList);
  yield takeEvery(restaurantsActions.getRestaurantDetails, getRestaurantDetails);
  yield takeEvery(restaurantMealSchedulesActions.createMealSchedules, createMealSchedules);
}
